import 'element-ui/lib/theme-chalk/index.css'
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  Card,
  Container,
  Footer,
  Header,
  Aside,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Message,
  Select,
  Option,
  OptionGroup,
  Divider,
  Tooltip,
  Switch,
  Table,
  TableColumn,
  Backtop,
  Icon
} from 'element-ui'

const components = [
  Button,
  Checkbox,
  CheckboxGroup,
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  Card,
  Container,
  Footer,
  Header,
  Aside,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Message,
  Select,
  Option,
  OptionGroup,
  Divider,
  Tooltip,
  Switch,
  Table,
  TableColumn,
  Backtop,
  Icon
]

export default function (app) {
  for (const component of components) {
    app.component(component.name, component)
  }
}
